import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-assessment-scores',
  templateUrl: './assessment-scores.component.html',
  styleUrls: ['../submissions/submissions.component.scss', './assessment-scores.component.scss']
})
export class AssessmentScoresComponent implements OnInit {

  constructor(private router:Router, private route: ActivatedRoute, private dataService: DataService) { }

  id:any = 0;
  data:any = {status:true, list:[]}
  newTool:any = "";
  newScore:any = "";
  submitting:any = false;

  ngOnInit() {
    this.route.parent.params.subscribe((params:any) => { 
      this.id = +params["id"];

    });

    this.loadData();
  }

  loadData(){
    this.dataService.getAssessmentScores(this.id).subscribe( (data: any )=> {
      this.data = data;
      console.log('forms', data);
      

    });
  }

  addScore(){
    if(this.newTool.length > 0 && this.newScore.length > 0){
      let data = {patient_id:this.id, tool:this.newTool, score:this.newScore}
      this.submitting = true;
      this.dataService.postAssessmentScore(data).subscribe( (res:any) => {
        this.submitting = false;
        if (res.status) {
          this.loadData();
          this.newScore = "";
          this.newTool = "";
        } else {
          alert(res.msg);
        }
      });
    }
  }

  deleteScore(row){
    let cnf = confirm("Are you sure you want to delete this entry?");

    if(cnf){
      let data = {id:row.id}
      this.dataService.postDeleteAssessmentScore(data).subscribe( (res:any) => {
        
        if (res.status) {
          this.loadData();
          
        } else {
          alert(res.msg);
        }
      });
    }
  }

}
